import * as React from 'react'

import { cn } from '@nwwp/ui-shadcn/lib/utils'

type InputProps = React.ComponentProps<'input'> & {
  prefix?: React.ReactNode
  // null = "reserve wrapper but no current error" (keeps DOM structure stable across validation changes)
  // undefined = no wrapper (bare <input>, safe for use as customInput inside react-number-format)
  error?: string | null
}

function Input({ className, type, prefix, error, ...props }: InputProps) {
  const inputEl = (
    <input
      type={type}
      data-slot="input"
      aria-invalid={error ? true : undefined}
      className={cn(
        'flex w-full rounded-sm bg-input px-4 py-3',
        'text-body text-black caret-ring',
        'shadow-[0_0_0_2px_var(--color-smoke)] transition-shadow',
        'placeholder:text-black/70',
        'hover:shadow-[0_0_0_2px_var(--color-ring)]',
        'focus:outline-none focus:shadow-[0_0_0_2px_var(--color-ring)]',
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-[0_0_0_2px_var(--color-smoke)]',
        'aria-invalid:shadow-[0_0_0_2px_var(--color-destructive)]',
        prefix && 'pl-7',
        className
      )}
      {...props}
    />
  )

  // No wrapper needed — caller did not reserve an error slot or prefix
  if (prefix === undefined && error === undefined) return inputEl

  return (
    <div>
      {prefix !== undefined ? (
        <div className="relative">
          <span className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 select-none text-neutral-darker">
            {prefix}
          </span>
          {inputEl}
        </div>
      ) : (
        inputEl
      )}
      {error && <p className="mt-2 text-subtitle text-red">{error}</p>}
    </div>
  )
}

export { Input }
export type { InputProps }
